export const WarningIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM9.24805 5.73047C9.24805 5.31626 9.58383 4.98047 9.99805 4.98047C10.4123 4.98047 10.748 5.31626 10.748 5.73047V11.7305C10.748 12.1447 10.4123 12.4805 9.99805 12.4805C9.58383 12.4805 9.24805 12.1447 9.24805 11.7305V5.73047ZM10.8496 14.8711C10.8496 15.3392 10.4701 15.7188 10.002 15.7188C9.53381 15.7188 9.1543 15.3392 9.1543 14.8711C9.1543 14.4029 9.53381 14.0234 10.002 14.0234C10.4701 14.0234 10.8496 14.4029 10.8496 14.8711Z"
        fill="#F0901E"
      />
    </svg>
  )
}
